import React from 'react';
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    TwitterIcon,
    FacebookIcon,
    LinkedinIcon,
    WhatsappIcon,
    EmailIcon
  } from "react-share";

  export default class ShareButton extends React.Component{
      render(){
          return(
            <div style={{display:'inline-flex'}}>
                <div style={{marginRight:'10px'}}><FacebookShareButton url={this.props.shareUrl} ><FacebookIcon size={32} round={true} /></FacebookShareButton></div>
                <div style={{marginRight:'10px'}}><TwitterShareButton url={this.props.shareUrl}><TwitterIcon size={32} round={true} /></TwitterShareButton></div>
                <div style={{marginRight:'10px'}}><LinkedinShareButton url={this.props.shareUrl} ><LinkedinIcon size={32} round={true} /></LinkedinShareButton></div>
                <div style={{marginRight:'10px'}}><EmailShareButton url={this.props.shareUrl}> <EmailIcon size={32} round={true} /> </EmailShareButton></div>
                <div ><WhatsappShareButton url={this.props.shareUrl}> <WhatsappIcon size={32} round={true} /> </WhatsappShareButton></div>
            </div>
          );
      }
  }